import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TruckGroupAdminComponent } from './component/truck-group-admin.component';
import { CommonFormattingModule, CommonLayoutModule, CommonUIModule, MasterDetailModule } from '@sdbn/common';
import { TruckGroupConditionsComponent } from './component/truck-group-conditions/truck-group-conditions.component';
import { TrucksComponent } from './component/trucks/trucks.component';
import { TruckGroupConditionComponent } from './component/truck-group-conditions/truck-group-condition/truck-group-condition.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TruckComponent } from './component/trucks/truck/truck.component';
import { TruckSearchComponent } from './component/trucks/truck-search/truck-search.component';
import { TruckGroupConditionSelectionComponent } from './component/truck-group-conditions/truck-group-condition-selection/truck-group-condition-selection.component';
import { TruckGroupConditionStationComponent } from './component/truck-group-conditions/truck-group-condition-station/truck-group-condition-station.component';

@NgModule({
  imports: [
    CommonModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonFormattingModule,
    ReactiveFormsModule,
    FormsModule,
    MasterDetailModule
  ],
  declarations: [
    TruckGroupAdminComponent,
    TruckGroupConditionsComponent,
    TrucksComponent,
    TruckComponent,
    TruckGroupConditionComponent,
    TruckSearchComponent,
    TruckGroupConditionSelectionComponent,
    TruckGroupConditionStationComponent,
  ],
  exports: [
    TruckGroupAdminComponent
  ]
})
export class TruckGroupAdminModule { }
